import {
  LOGO_PROJECTTION,
  bynderImageProjection,
  computedInternalUrl,
  internalReferenceUrl,
} from './projection';
import { namespaceType } from './namespace';

const headerType = namespaceType('header');
const navigationItemLevel1Type = namespaceType('navigationItemLevel1');
const navigationItemLevel3Type = namespaceType('navigationItemLevel3');

export const internalReference = (field = 'internalReference') => `
  ${field}->{
    _id,
    _type,
    name,
    "url": ${computedInternalUrl}
  }
`;

export const HEADER_MEGA_MENU_QUERY = `
  *[_type == "${headerType}"][0] {
    "headerLogo": ${LOGO_PROJECTTION},
    "navigationItems": megaMenuNavigationItems[] {
      _type == "${navigationItemLevel1Type}" => {
        ...,
        "navigationType": "level1",
        "label": title,
        link{
          ...,
          ${internalReference()}
        },
        advertisingBanner {
          ...,
          ${bynderImageProjection('image', 'bynderAdvertisingBannerImage')},
          bynderAdvertisingBannerImage,
          isEnabled,
          "label": text,
          link{
            "type": link.type,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(link.isOpenInNewTab, link.newTab)
          }
        },

        "childrenColumn": select(
          layoutType == "column" => childrenColumn[] {
            ...,
            "navigationType": "level2Column",
            "label": title,
            link{
              ...,
              ${internalReference()}
            },
            "childrenColumn": children[] {
              _type == "${navigationItemLevel3Type}" => {
                ...,
                "navigationType": "level3",
                "label": title,
                link{
                  ...,
                  ${internalReference()}
                },
              }
            }
          }
        ),

        "childrenGrid": select(
          layoutType == "grid" => childrenGrid[] {
            ...,
            "navigationType": "level2Grid",
            ${internalReference('link')},
            "label": title,
            description,
            ${bynderImageProjection('thumbnail', 'bynderThumbnail')},
            bynderThumbnail,
          }
        )
      }
    },
    "primaryButton": primaryButton{
      ...,
      link{
        ...,
        "url": ${internalReferenceUrl},
      }
    }
  }
`;
